import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import {TableDataSource} from "../../../utils/table-data-source";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import { ActivatedRoute, Router } from '@angular/router';
import { PATH_PERMISO_DETAIL } from '../../../navigation/navigation.module';
import { PermisosService } from '../../../services/permisos-service';

@Component({
  selector: 'app-permisos-list',
  templateUrl: './permisos-list.component.html',
  styleUrls: ['./permisos-list.component.scss']
})
export class PermisosListComponent implements OnInit {

  permisosColumns = ['nombre'/*, 'fechaModificacion'*/];
  permisos = [];

  dataSourceSubject$ = new BehaviorSubject<any[]>([]);
  dataSource = new TableDataSource(this.dataSourceSubject$);

  constructor(private router: Router,
              private permisosService: PermisosService) {
  }

  ngOnInit() {
    this.permisosService.getAllPermisos().subscribe(x => {
      this.permisos = x;
      this.dataSourceSubject$.next(this.permisos);
    });
  }

  goToDetail(e) {
    this.router.navigate([PATH_PERMISO_DETAIL, e.PermisoId]);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/permisos-list/permisos-list.component.ts